/* Shared Atelier presentation only. The existing compose bridge owns busy/draft
   protection, and its Send button remains the only path to an AI request. */
(() => {
  const root = document.querySelector('[data-fp-assistant][data-atelier-a]');
  if (!root || root.dataset.atelierInitialized) return;
  root.dataset.atelierInitialized = 'true';
  const find = name => root.querySelector(`[data-assistant-${name}]`);
  const brief = find('brief');
  const briefToggle = find('brief-toggle');
  const input = find('input');
  function showBrief(show) {
    brief.hidden = !show;
    briefToggle.setAttribute('aria-expanded', String(show));
    briefToggle.textContent = show ? briefToggle.dataset.closeLabel : briefToggle.dataset.openLabel;
    if (show) brief.querySelector('input')?.focus({preventScroll:true});
  }
  function compose(text, trigger) {
    const previous = input.value;
    document.dispatchEvent(new CustomEvent('fivepoint:assistant-compose', {detail:{text,trigger}}));
    // The native controller rejects pending requests and nonempty drafts. Do not
    // conceal the brief or clear choices when that rejection leaves input unchanged.
    if (!previous.trim() && input.value === text) { showBrief(false); input.focus({preventScroll:true}); }
  }
  root.addEventListener('click', event => {
    const target = event.target.closest('button');
    if (!target) return;
    if (target.hasAttribute('data-assistant-brief-toggle')) showBrief(brief.hidden);
    if (target.hasAttribute('data-assistant-quick-toggle')) {
      const more = find('quick-more');
      more.hidden = !more.hidden;
      target.setAttribute('aria-expanded', String(!more.hidden));
      target.textContent = more.hidden ? target.dataset.moreLabel : target.dataset.lessLabel;
    }
    if (target.hasAttribute('data-assistant-draft')) compose(target.dataset.assistantDraft,target);
    if (target.hasAttribute('data-assistant-brief-use')) {
      const text = [...brief.querySelectorAll('[data-assistant-brief-group]')].flatMap(group => {
        const values = [...group.querySelectorAll('input:checked')].map(option => option.value);
        return values.length ? [`${group.dataset.groupLabel}: ${values.join(', ')}`] : [];
      }).join('\n');
      if (text) compose(text,target);
    }
  });
  brief.addEventListener('change', () => {find('brief-use').disabled = !brief.querySelector('input:checked');});
  // Reset presentation only after the existing confirmed reset actually succeeds.
  root.addEventListener('fivepoint:assistant-reset', () => {
    brief.querySelectorAll('input').forEach(option => {option.checked=false;});
    find('brief-use').disabled=true;
    showBrief(false);
    find('quick-more').hidden=true;
    find('quick-toggle').setAttribute('aria-expanded','false');
    find('quick-toggle').textContent=find('quick-toggle').dataset.moreLabel;
  });
})();
